import { Inject } from '@angular/core';
import '@angular/compiler';
import { PageQuizSettingComponent } from './page.quiz.setting/page.quiz.setting.component';
import { PageRegisterComponent } from './page.register/page.register.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageQuizPlayComponent } from './page.quiz.play/page.quiz.play.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageWrongNoteComponent } from './page.wrong.note/page.wrong.note.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageAdminSubjectsComponent } from './page.admin.subjects/page.admin.subjects.component';
import { PageAdminQuestionsComponent } from './page.admin.questions/page.admin.questions.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageTextbookStudyComponent } from './page.textbook.study/page.textbook.study.component';
import { PageQuizResultComponent } from './page.quiz.result/page.quiz.result.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageTextbookListComponent } from './page.textbook.list/page.textbook.list.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageMockExamComponent } from './page.mock.exam/page.mock.exam.component';
import { PageSubjectItemComponent } from './page.subject.item/page.subject.item.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PageQuizSettingComponent,
        PageRegisterComponent,
        ComponentNavSidebarComponent,
        PageMembersComponent,
        PortalSeasonModalComponent,
        PageDashboardComponent,
        LayoutSidebarComponent,
        PortalSeasonTreeComponent,
        PageQuizPlayComponent,
        PortalSeasonFormDropdownComponent,
        PageMypageComponent,
        PageWrongNoteComponent,
        PageAccessComponent,
        PageAdminSubjectsComponent,
        PageAdminQuestionsComponent,
        PortalSeasonPaginationComponent,
        PageTextbookStudyComponent,
        PageQuizResultComponent,
        LayoutEmptyComponent,
        PortalSeasonLoadingSeasonComponent,
        PageTextbookListComponent,
        PortalSeasonLoadingDefaultComponent,
        PageMockExamComponent,
        PageSubjectItemComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }